import { TextArea } from '@blueprintjs/core';
import { useDebounce } from '@hogwarts/ui-components-core';
import React, { useState } from 'react';
import { getErrorIntent } from './utils';

const DEBOUNCE_TIME = 250;

const TextAreaComponent = ({
  fieldKey,
  formField,
  readOnly,
  placeHolder,
  fieldMeta,
  fieldHelpers,
  maxLength,
}) => {
  const [value, setValue] = useState(null);
  let showValue = value === null ? formField.value : value;
  if (showValue == null) showValue = '';

  const onChangeHandler = useDebounce((value) => {
    fieldHelpers.setTouched(true, false);
    fieldHelpers.setValue(value);
    setValue(null);
  }, DEBOUNCE_TIME);

  return (
    <TextArea
      id={fieldKey}
      intent={getErrorIntent(fieldMeta)}
      onBlur={(event) => {
        let value = event.target.value;
        if (value !== null) {
          fieldHelpers.setTouched(true, false);
          fieldHelpers.setValue(value, true);
          setValue(null);
        }
      }}
      onChange={(event) => {
        let value = event.target.value;
        onChangeHandler(value);
        setValue(value);
      }}
      placeholder={placeHolder}
      value={showValue}
      disabled={readOnly}
      maxLength={maxLength}
      fill
      growVertically={false}
    />
  );
};

export default {
  name: 'Text Area',
  options: [],
  label: true,
  Component: TextAreaComponent,
};
